export default {
  quoteCommon: {
    close: '关闭',
    length: '长度',
    width: '宽度',
    height: '高度',
    box_type: '箱型',
    Match_number: '配数',
    material_type: '材质',
    flute_type: '楞型',
    del_sucess: '删除成功',
    del_failed: '删除失败',
    cancel_del: '已取消删除',
    copy: '复制',
    modify: '修改',
    View: '查看',
    search: '查询',
    new: '新建',
    Delete: '删除',
    pleaseEnter: '请输入',
    Input_format: '输入格式',
    Application_form_number: '申请单号',
    Estimate_No: '估价单号',
    Customer_number: '客户编号',
    Customer_name: '客户名称',
    Product_number: '产品编号',
    Product_size: '产品尺寸',
    Product_name: '产品名称',
    Number_of_products: '产品数量',
    Please_select: '请选择',
    Whole: '全部',
    Not_approved: '未批核',
    Approved: '已批核',
    Replied: '已回复',
    No_reply: '未回复',
    Status: '状态',
    typeOfGoods: '货品种类',
    Please_enter_a_keyword: '请输入关键字',
    Please_enter_customer_information_first: '请先输入客户信息',
    The_user_has_no_permission_to_view_the_quotation_information_of_this_customer: '用户没有该客户报价信息的查看权限',
    Details: '详情',
    Remark: '备注',
    Quotation: '报价',
    Template: '样板',
    Quantity: '数量',
    Dimensional_units: '尺寸单位',
    Quotation_clerk: '报价员',
    Operation: '操作',
    Confirm: '确 认',
    Cancel: '取 消',
    Download: '下载',
    Upload: '上传',
    Molding_size: '成型尺寸',
    Sticky_edge: '粘边',
    Socket: '插口',
    Download_the_knife_diagram: '下载刀线图',
    Copy_the_product: '复制产品',
    Delete_the_product: '删除产品',
    Copy_the_component: '复制部件',
    Delete_the_component: '删除部件',
    The_format_of_the_molding_dimension_entered_is_wrong: '输入的成型尺寸格式有误',
    The_input_molding_size_is_smaller_than_molding_size_of_the_wooden_box: '请注意：输入的成型尺寸比木盒的成型尺寸小',
    Verification_successful: '验证成功',
    Verification_failed: '验证失败',
    delete_it_or_not: '是否删除此数据？',
    tips: '提示',
    open_version: '开版',
    open_version_with_hand: '手动开版',
    name: '名称',
    Type: '类型',
    Serial_number: '序号',
    Success: '成功',
    Preservation: '保存',
    Opportunities: '商机',
    ReturnReport:'退回报表',
  },
  analyze: {
    title: '部门/天/开单量',
    pitCarton: '坑纸箱',
    bookEdition: '书版类',
    colorBox: '彩盒类',
    boutiqueBox: '精品盒',
    woodenBox: '木盒',
  },
  bbkPart: {
    Add_Components: '添加部件',
    Size: '尺寸',
    Thickness: '厚度',
    Total_PP_number: '总PP数',
    PP_number: 'PP数',
    Match_number: '配数',
    Couplet: '联本',
    Packing: '包装',
    Single_copy: '单联本',
    Double_copy: '双联本',
    Triple_copy: '三联本',
    Quadruple_copy: '四联本',
    Five_copy: '五联本',
    Six_copy: '六联本',
    Straightness_book: '直度书',
    Horizontal_book: '横度书',
    Failed_to_load_the_online_oiling_data_source: '加载连机过油数据源时失败',
    Total_PP_number_cannot_be_odd: '总PP数不能为奇数！',
    The_format_of_the_input_product_size_is_wrong: '输入的产品尺寸格式有误!',
    The_layout_size_must_be_larger_than_expanded_size: '排版尺寸必须大于展开尺寸',
    Paper_size_must_be_larger_than_layout_size: '开纸尺寸必须大于排版尺寸',
    Adhesive_binding: '胶装',
    Riding_Nail: '骑钉',
    Folding: '折页',
  },
  bltPart: {
    Thickness: '厚度',
    Blister_type: '吸塑类型',
    Skirt: '裙边',
    Trimming: '切边',
    Alien: '异形',
    Other: '其他',
    The_format_of_the_input_molding_size_is_wrong: '输入的成型尺寸格式有误!',
  },
  bookCategoryCMPT: {
    Cover: '封面',
    Txt_input: 'txt输入',
    Please_enter_an_attribute: '请输入属性',
    length_1_to_5: '长度在 1 到 5 个字符',
    Please_select_a_value: '请选择一项值',
    Option_one: '选项一',
    Option_two: '选项二',
    Radio_box: '单选框',
    Check_box: '复选框',
    Inside_page: '内页',
    Title_page: '扉页',
  },
  Customer: {
    Account_opening_number_of_the_customer: '客户开户单号',
    Account_opening_time: '开户时间',
    The_entry_time_cannot_be_later_than_or_equal_to_the_entry_time: '录入时间起不能大于等于录入时间止',
    Query_succeeded: '查询成功',
    Retrieve: '检索',
    Delete_current_row_data: '是否删除当前行数据?',
    The_operation_was_canceled: '已取消操作',
  },
  erpQuote: {
    Quotation_number: '报价单号',
    Basic_information_of_quotation: '报价基本资料',
    Valuation_Version: '估价版本',
    Several_periods: '数期',
    Tax_included_or_not: '是否含税',
    VAT_rate: '增值税率',
    Payment_method: '付款方式',
    Order_unit: '订单单位',
    Discount_rate: '折扣率',
    Trading_company: '交易公司',
    Annual_estimated_production_quantity: '年度预计生产数量',
    Quotation_feedback: '报价反馈',
    Quote_version: '报价版本',
    Feedback_comments: '反馈备注',
    Creator: '制单人',
    Creation_date: '制单日期',
    Modified_by: '修改人',
    Date_of_modification: '修改日期',
    Approved_by: '批核人',
    Date_of_approval: '批核日期',
    Feedback_person: '反馈人',
    Feedback_time: '反馈时间',
    Component: '部件',
    Component_number: '部件料号',
    Proportioning: '配比',
    Content: '内容',
    Quoted_quantity: '报价数量',
    Number_of_spare_parts: '备品数',
    Calculate_the_quantity: '计算数量',
    Money: '货币',
    Sales_Quotation_Unit_Price_Local_currency: '销售报价单价(本币)',
    Cost_amount: '成本金额(￥)',
    Cost_unit_price: '成本单价(￥)',
    Additional_costs: '额外费用',
    Charge_ratio: '收费比例',
    Actual_receipt: '实收',
    Quotation_unit_price: '报价单价(￥)',
    Profit_margin: '利润率',
    Suggested_quotation_unit_price_excluding_taxL: '建议报价单价(不含税)(￥)',
    Suggested_quotation_unit_price_tax_include: '建议报价单价(含税)(￥)',
    Suggested_Quotation_Unit_Price_Local_currency: '建议报价单价(本币)',
    Actual_profit_margin: '实附利润率',
    Material_cost: '物料成本',
    Shipping_cost: '运费',
    Date_of_valuation: '估价日期',
    Entry_date: '录入日期',
    Entered_by: '录入人',
    Date_of_calculation: '计算日期',
    Tax_rate: '税率',
    Exchange_rate: '汇率',
    Missing_estimate_number_parameter: '缺少估价单号参数',
    Modification_succeeded: '修改成功',
    Modification_failed: '修改失败',
    Quote_information_is_incomplete_and_cannot_be_saved: '报价信息不完整，无法保存',
  },
  quoteQuery: {
    no: '单号',
    pleaseEnter: '输入申请单号或估价单号',
    startDate: '开始日期',
    endDate: '结束日期',
    myOrder: '我的单',
    moreConditions: '更多条件',
    newPitCarton: '新建坑纸箱',
    businessDepartment: '营业部门',
    creationTime: '创建时间',
    Created_by: '创建人',
    Quotation_clerk: '报价员',
    Application_status: '申请状态',
    Valuation_status: '估价状态',
    Ergonomic_information: '工效信息',
    Inquiry_information: '询价信息',
  },
  reqQuoteMgmt: {
    Preservation: '保存',
    Approval: '批核',
    Unlock_the_approval: '解批',
    SendBack: '退回',
    ReturnReasons: '退回原因',
    Please_enter_a_return_reason: '请输入退回原因',
    Preview: '预览',
    Cost_analysis: '成本分析',
    RealTtimeCosts: '实时成本',
    ReadBOM: '读取BOM',
    Copy: '复制',
    Revision: '修订',
    Next_page: '下一页',
    Previous_page: '上一页',
    Page_one: '第一页',
    Basic_data: '基础资料',
    Click_to_view_historical_version: '点击查看历史版本',
    Money: '货币',
    Quality_requirements: '质量要求',
    Safety_standards: '安全标准',
    European_Union_2011_65_EU_RoHS2_0: '欧盟2011/65/EU RoHS2.0',
    EU_Packaging_Directive_94_62_EC: '欧盟包装指令 94/62/EC',
    EU_REACH_EC_1907_2006: '欧盟REACH EC/1907/2006',
    Halogen: '卤素',
    Phthalate: '邻苯二甲酸盐',
    Toy_part_migration_element: '玩具部件迁移元素',
    Consumer_Product_Safety_Act: '美国消费品安全法',
    Polycyclic_aromatic_hydrocarbons: '多环芳香烃',
    Proofing_sheet_No: '打样单号',
    Parts_are_quoted_separately: '部件分开报价',
    Business_Center_Quotation_Recipient: '营业中心报价接收人',
    Production_Business_Division: '生产事业处',
    Quotation_setting: '报价设定',
    One_price: '一口价',
    Step_price: '阶梯价',
    Quoted_quantity: '报价数量',
    Billing_person: '开单人',
    Billing_time: '开单时间',
    Modified_by: '修改人',
    Modified_time: '修改时间',
    Approved_by: '批核人',
    Approved_time: '批核时间',
    Comment_information: '备注信息',
    Contents_of_the_appraisal_reply: '估价回复内容',
    Enclosure: '附件',
    Please_add_a_file: '请添加文件',
    File_name: '文件名称',
    Upload_failed: '上传失败',
    Appendices_to_the_Valuation_Results: '估价结果附件',
    No_documents_are_available: '暂无文件',
    Add_a_product: '添加产品',
    Assembly: '装配件',
    Packing: '包装',
    Transportation: '运输',
    Please_select_a_small_operation: '请选择小工序',
    The_starting_point: '起点',
    FOB_port: 'FOB港口',
    Overseas_ports: '海外港口',
    Overseas_destinations: '海外目的地',
    Delivery_address: '交货地址',
    Kilometers: '公里数',
    Select_an_address: '选择地址',
    Address: '地址',
    Select_a_customer: '选择客户',
    Please_enter_customer_number_or_name_to_search: '请输入客户编号或名称检索',
    Retrieve: '检索',
    Enter_keywords_to_filter: '输入关键字进行过滤',
    Knife_line_diagram: '刀线图',
    Download_the_knife_diagram: '下载刀线图',
    Domestic: '国内',
    Hong_Kong: '香港',
    Abroad: '国外',
    Bonded_Zone: '保税区',
    Customer_name_cannot_be_empty: '客户名称不能为空',
    length1_200: '长度在 1 到 200 个字符',
    length0_200: '长度在 0 到 200 个字符',
    Length_cannot_be_greater_than_20_characters: '长度不能大于20字符',
    Quantity_cannot_be_blank: '数量不能为空',
    Production_business_department_cannot_be_empty: '生产事业处不能为空',
    Stone_row: '石排',
    Bridge_head: '桥头',
    Tangxia: '塘厦',
    Select_a_product: '选择产品',
    You_haven_t_saved_yet_Are_you_sure_you_want_to_navigate_away_from_this_page: '您还未保存，确定需要离开此页面吗?',
    Hint: '提示',
    You_do_not_have_permission_to_view_this_page: '您无权查看该页面',
    Outsourcing_category: '外购类',
    Is_the_value_you_entered_also_converted_based_on_the_unit_of_measure: '你输入的值是否也要根据单位换算?',
    Yes: '是',
    No: '否',
    Products: '产品：',
    the_converted_product_size_is_less_than_1_inch: ' 的产品尺寸换算后小于1英寸!',
    The_unit_conversion_is_successful: '单位换算成功!',
    Only_the_unit_is_switched_and_the_input_value_is_not_converted: '只切换单位，输入值没有换算!',
    N_Plain_packing: 'N 普通包装',
    Virtual_Product_Packaging_and_Transportation: '虚拟产品-包装运输',
    Transportation_charge_based_on_CBM: '按CBM计运输费',
    Punch_card_board: '打卡板',
    The_order_number_does_not_exist: '该单号不存在',
    The_internal_material_consultation_sheet_No_issued_in_this_document_is_as_follow: '本单开出物料内部咨询单号如下',
    The_number_of_the_pre_work_efficiency_consultation_sheet_issued_in_this_sheet_is_as_follows: '本单开出预工效咨询单号如下',
    Intra_province_transportation_by_CBM: '省内运输(按CBM)',
    Primary_Color: '原色',
    General_college: '普通专',
    White_ink: '白墨',
    Metal_fluorescent_special: '金属/荧光专',
    Connect_the_machine_for_oil_passing: '连机过油',
    The_maximum_number_of_quote_quantity_lines_is_8: '报价数量行数最多为8行!',
    Upload_succeeded: '上传成功',
    The_maximum_file_can_be_uploaded_is_10_M: '最大文件可以上传10M',
    Deleted_successfully: '删除成功',
    Delete_failed: '删除失败',
    Are_you_sure_to_remove: '确定移除',
    Cancel_the_deletion: '取消删除',
    Keyword_cannot_be_less_than_4_characters: '关键字不能少于4个字符',
    You_do_not_have_permission_to_view_this_customer_quote_information: '您没有该客户报价信息的查看权限',
    Delete_this_data: '是否删除此数据?',
    The_deletion_was_canceled: '已取消删除',
    You_do_not_have_permission_to_modify: '您没有修改权限',
    Not_approved_no_revision_required_can_be_modified_and_saved: '此单未批核，不需要修订，可以直接修改保存',
    error1: '当前估价单未计算或未批核, 不需要修订, 可直接通知估价部解锁以进行修改',
    You_have_no_permission_to_unapprove: '您没有解批权限',
    error2: '此单未批核，无需解批',
    You_do_not_have_approval_authority: '您没有批核权限',
    error3: '此单已批核,请解批后再次审批',
    You_do_not_have_the_right_to_return: '您没有退回权限',
    error4: '此单未批核，无需退回',
    Please_set_up_a_quote_recipient_for_the_business_center: '请设置营业中心报价接收人',
    Please_set_up_a_quotation_clerk: '请设置报价员',
    No_operation_selected: '未选择工序',
    Small_operation_item_is_not_filled_in: '未填写小工序项',
    Process_parameter_is_required: '工艺参数为必填项',
    Brand: '品牌',
    Gram_weight: '克重',
    When_selecting_a_paper_pack: '选择纸包时, ',
    Required: '必选项',
    When_selecting_a_pallet_there_must_be_an_operation_material: '选择卡板时，必须要有工序物料',
    When_selecting_a_card_the_card_type_must_be_selected: '选择卡板时，必须选择卡板类型',
    Set_to_blank_box_and_select_again: '设置为空白箱，又选择了',
    Printing_process: '印刷工序',
    If_printing_is_selected_the_printing_color_must_be_filled_in: ' 选择了有印刷，必须填写印色',
    Printing_is_selected_printing_process_must_be_selected: '选择了有印刷，必须选择印刷工序',
    Paper_size_die_size: '开纸尺寸 / 刀模尺寸',
    Number_of_opened_papers: '开纸个数',
    Non_numeric_values_appear_in_opening_size_die_size_and_number_of_opening: '开纸尺寸，刀模尺寸,开纸个数 出现了非数字值',
    Number_of_cuts_is_required_and_is_greater_than_0: '刀数为必填项，且大于0',
    Length_width_and_height_are_empty: '长宽高为空',
    Length_and_width_are_empty: '长宽为空',
    Material_is_empty: '材质为空',
    The_material_ratio_column_data_is_incorrect: '用料比列数据有误（正确值应为：1、2、4）',
    Size_Long: '尺寸-长',
    Size_wide: '尺寸-宽',
    Type_of_material: '物料类型',
    Paper_stock_type: '纸料类型',
    Material: '物料',
    Is_empty: '为空',
    Please_select_the_opening_information: '请选择开版信息',
    Pit_paper_information_must_be_selected_for_pit_mounting_process: '裱坑工序必须选坑纸信息',
    The_color_box_shall_not_have_pit_mounting_PA3_and_card_mounting_PA4_processes_at_the_same_time: '彩盒不能同时存在裱坑(PA3)和裱咭(PA4)工序',
    Please_enter_print_color_information: '请输入印色信息',
    The_basic_primary_colors_are_up_to_4_colors: '基础原色最多为4色',
    You_have_selected_double_sided_printing_Please_enter_the_correct_color_information_for_the_front_and_back_sides: '您选择了双面印刷，请正确的输入正面和底面的印色信息',
    Version_opening_information_is_empty: '开版信息为空',
    Please_select_the_transport_origin: '请选择运输起点',
    Please_select_the_shipping_FOB_port: '请选择运输FOB港口',
    Please_select_the_overseas_port_of_shipment: '请选择运输海外港口',
    Please_select_the_overseas_destination_for_shipping: '请选择运输海外目的地',
    If_you_choose_transportation_you_must_have_the_number_of_kilometers: '选择了运输,必须要有公里数',
    Modulus_cannot_be_0: '模数不能为0',
    Die_size_should_be_greater_than_developed_size_modulus: '刀模尺寸应大于展开尺寸*模数',
    The_product_size_in_the_manual_is_incorrect: '说明书产品尺寸有误',
    PP_number_of_each_part_of_the_book_cannot_be_an_odd_number: '书籍各部件的PP数不能为奇数',
    PP_number_of_each_part_of_the_book_cannot_be_null: '书籍各部件的PP数不能为空',
    Please_select_the_opening_information_of_each_part_of_the_book: '请选择书籍各部件的开版信息',
    Error_prompt: '错误提示',
    Please_fill_in_the_number_of_kilometers_of_transportation: '请填写运输的公里数',
    Internal_packing_is_selected_for_packing_and_external_packing_must_be_selected: '包装选择内装箱，必须选择外装箱',
    Please_fill_in_the_packing_information: '请填写包装信息',
    You_do_not_have_permission_to_add: '您没有新增权限',
    This_document_has_been_approved_Please_unapprove_it_before_saving: '此单已批核,请解批后再保存',
    Please_select_a_quality_requirement: '请选择质量要求',
    Please_select_a_product_type: '请选择货品种类',
    Please_enter_a_quote_quantity: '请输入报价数量',
    Delete_the_unfilled_part_of_material_or_size_and_continue_to_save: '删除材质或尺寸未填部件，继续保存',
    After_completion_save_again: '完善后，再保存',
    Saved_successfully: '保存成功',
    The_request_number_is: '请求单号：',
    Please_wait_for_approval: '批核中请稍候。。。',
    There_is_a_problem_with_approval_please_refresh_the_page_before_trying: '批核出现问题，请刷新页面在试！',
    There_is_an_error_in_cost_pricing: '成本计价有误',
    Approved_successfully: '批核成功',
    Relevant_personnel_of_the_Quotation_Department_have_been_informed: '已通知报价部相关人员',
    Inform_the_Quotation_Department_of_Abnormity: '通知报价部异常异常',
    Developer_no_notification_information: '开发人员,未发通知信息',
    Approval_failed: '批核失败',
    Unblock_successfully: '解批成功',
    Revision_succeeded: '修订成功',
    Return_succeeded: '退回成功',
    Can_be_saved_and_approved_again: '可以重新操作保存及批核',
    Please_complete_the_information_before_saving_it: '请先完善信息，再进行保存',
    Initializing_data: '正在初始化数据……',
    Please_complete_the_data_and_save_it_before_printing: '请完善资料保存之后再打印',
    You_do_not_have_permission_to_print: '您没有打印权限',
    No_product_description: '无产品描述',
    Product_description: '产品描述：',
    Outsourcing: '外购',
    Select_the: '选择',
    product: '产品',
    Sky_box_tissue: '天盒面纸',
    Sky_box_and_grey_board: '天盒灰板',
    Sky_box_lining_paper: '天盒衬纸',
    Ground_box_tissue: '地盒面纸',
    Floor_box_ash_board: '地盒灰板',
    Box_lining_paper: '地盒衬纸',
    Sky_box_ground_box_tissue: '天盒&地盒面纸',
    Sky_box_ground_box_ash_plate: '天盒&地盒灰板',
    Sky_box_ground_box_lining_paper: '天盒&地盒衬纸',
    Box_cover_paper: '盒盖面纸',
    Grey_plate_of_box_cover: '盒盖灰板',
    Box_cover_lining_paper: '盒盖衬纸',
    Box_surface_paper: '盒体面纸',
    Grey_plate_of_box_body: '盒体灰板',
    Box_body_lining_paper: '盒体衬纸',
    Cover_paper: '外盖面纸',
    Grey_plate_of_outer_box: '外盒灰板',
    Outer_box_lining_paper: '外盒衬纸',
    Inner_box_tissue: '内盒面纸',
    Inner_box_ash_plate: '内盒灰板',
    Inner_box_lining_paper: '内盒衬纸',
    Outer_cover_inner_box_tissue: '外盖&内盒面纸',
    Outer_box_inner_box_ash_plate: '外盒&内盒灰板',
    Outer_box_inner_box_lining_paper: '外盒&内盒衬纸',
    Wood_panel: '木面板',
    Left_side_plate: '左侧板',
    Front_plate: '前板',
    Wooden_floor: '木底板',
    Right_side_plate: '右侧板',
    Back_plate: '后板',
    Face_base_plate: '面+底板',
    Left_right_side_plate: '左+右侧板',
    Front_back_plate: '前+后板',
    Assemble: '组装作',
    Please_select_a_product_first: '请先选择产品',
    warning1: '因系统有新版本发布，新版本和旧版本数据会有冲突，所以无法复制本单！',
    Template: '样板',
    pitCarton: '坑纸箱',
    Other: '其他',
    Warning: '警告',
    Quote_line_is_not_filled_in: '未填写报价项',
    Please_select_the_layout_information: '请选择排版信息',
    Calculate_costs_in_real_time: '实时计算成本',
    Please_wait_while_the_cost_is_calculated: '成本计算中请稍候。。。',
    There_was_a_problem_with_the_calculation_please_refresh_the_page_and_try_again: '计算出现问题，请刷新页面在试！',
    Get_BOM_information: '获取BOM信息',
    BOMNo: 'BOM编号',
    BOMItemNo: '客户料号',
    Please_select_a_customer_first: '请先选择客户',
    Please_enter_the_product_name: '请输入产品名称',
    Please_enter_the_BOM_number_or_customer_part_number: '请输入BOM编号或者客户料号',
    BOM_information_does_not_exist: 'BOM信息不存在',
    There_is_no_current_product_category_information: '没有当前货品种类信息',
    Product_information_is_being_obtained_please_wait_for_a_moment_before_operating: '产品信息获取中，请稍候在操作！',
    Salesperson_makes_his_own_quotation: '业务员自己报价',
    SelectOpportunities: '选择商机',
    Code: '编号',
    CustName: '客户名称',
    FollowUpUser: '跟进人',
    OpportunitiesCode: '商机编号',
    OpportunityDate: '商机日期',
    OpportunityStage: '商机阶段',
    SalesDepartment: '营业部',
    IntendedProducts: '意向产品',
    Please_select_a_business_opportunity: '请选择商机！',
    Wrong_size_information: '卡板尺寸信息有误',
  },
  generalPackingCMPT: {
    input_email: '请输入邮箱地址',
    input_right_email: '请输入正确的邮箱地址',
    url_null: '域名不能为空',
    url: '域名',
    submit: '提交',
    addurl: '新增域名',
    reset: '重置',
  },
  wboxPart: {
    Add_Components: '添加部件',
    Download_the_knife_diagram: '下载刀线图',
    Copy_product: '复制产品',
    Del_product: '删除产品',
    del_sucess: '删除成功',
    cancel_del: '已取消删除',
    wrong_format: '输入的成型尺寸格式有误!',
  },
  pitPart: {
    name: '名称',
    Add_Components: '添加部件',
    Copy_product: '复制产品',
    Del_product: '删除产品',
    item_code: '材质代号',
    item_name: '材质名称',
    cust_item: '客户材质',
    box_type: '箱型',
    black: '空白箱',
    hasColor: '有印刷',
    colorNum: '印色数',
    bigBackgroud: '大地',
    out_de: '(外度)',
    paper_inch: '开纸尺寸(INCH)',
    knift_inch: '刀模尺寸(INCH)',
    count: '计算',
    clear: '清除',
    hk: '横坑',
    model_num: '模数',
    z: '纵',
    h: '横',
    kzgs: '开纸个数',
    zk: '撞口',
    dt: '钉条',
    db: '单驳',
    sb: '双驳/多驳',
    item_rate: '用料比列',
    knift_num: '刀数',
    expandsize: '开版尺寸',
    countprice: '客人的计价',
    formula: '面积公式',
    knif_size: '刀模尺寸',
    package: '包装',
    must_biger1: '排版尺寸必须大于展开尺寸',
    must_biger2: '开纸尺寸必须大于排版尺寸',
    selectitemtype: '请选择材质代号',
    selectlengx: '请选择愣型',
    selectxx: '请选择箱型',
    inputsizelen: '请输入尺寸-长',
    inputsizewid: '请输入尺寸-宽',
    inputopen_sizehig: '请输入展开尺寸-高',
    inputopen_sizelen: '请输入展开尺寸-长',
    inputopen_sizewid: '请输入展开尺寸-宽',
    inputkn_sizelen: '请输入刀模尺寸-长',
    inputkn_sizewid: '请输入刀模尺寸-宽',
    inputsizehig: '请输入尺寸-高',
    inautoCount: '啤箱(异形箱)无法自动计算展开尺寸，请手动输入展开尺寸！',
    countSucess: '展开尺寸：计算成功',
    countFail: '展开尺寸：计算失败(',
    neterr: '展开尺寸：计算网络异常(',
    serEx: '展开尺寸：计算服务响应异常(',
    knifsucce: '刀模尺寸/模数：计算成功',
    kniffail: '刀模尺寸/模数：计算失败(',
    knifnetfail: '刀模尺寸/模数：计算网络异常(',
    knifserEx: '刀模尺寸/模数：计算服务响应异常(',
    oppsucce: '开纸尺寸/开纸个数：计算成功',
    oppfail: '开纸尺寸/开纸个数：计算失败(',
    oppnetfail: '开纸尺寸/开纸个数：计算网络异常(',
    oppserEx: '开纸尺寸/开纸个数：计算服务响应异常(',
    do_not_less_wid: '开纸尺寸宽不能小于或等于刀模尺寸宽',
    do_not_less_len: '开纸尺寸长不能小于刀模尺寸长',
    occ: '开纸个数:计算成功',
    p_i_s: '请正确输入刀模尺寸，开纸尺寸',
  },
  pbxPart: {
    input_format: '输入格式：200*100*100',
    format_wrong: '输入的成型尺寸格式有误!',
  },
  packagePart: {
    perweight: '单重',
    countprowei: '计算产品数量',
    minpacksize: '最小包装尺寸',
    maxpacksize: '最大包装尺寸',
    maxmz: '最大毛重',
    sys_count: '系统计算',
    item: '材质',
    in_box: '内箱',
    type: '类型',
    paper_pack: '纸包',
    inside_size: '箱内尺寸',
    pro_size: '产品包装尺寸',
    per_pro_size: '单个产品包装尺寸',
    load: '装箱',
    load_way: '装箱方式',
    lay_way: '摆放方式',
    weight: '克重',
    band: '品牌',
    layCount: '层数',
    perBackNu: '每包数量',
    len: '长:',
    wid: '宽:',
    hig: '高:',
    len2: '长',
    wid2: '宽',
    hig2: '高',
    out_box: '外箱',
    card: '卡板',
    totalHight: '总高(含脚)',
    perCarWeight: '每个卡板承载重量',
    lx: '愣型',
    xx: '箱型',
    add_flag_car: ' 添加平卡',
    kezhong: '克重',
    thick_coefficient: '厚度系数:',
    num: '数量',
    b_c: '摆长',
    b_k: '摆宽',
    b_g: '摆高',
    tj: '推荐',
    tj_box: '推荐纸箱',
    tj_box_list: '推荐纸箱列表',
    show_all_result: '显示全部结果',
    re_count: '重新计算',
    put: '摆放',
    sz: '尺寸',
    perload: '每箱装',
    w: '重量',
    box_num: '箱数',
    all_cbm: '卡板数',
    car_num: '总CBM',
    PalltPreBoxCount: '每卡板装',
    count: '测算',
    perinsidenum: '每箱内箱数',
    perproductnum: '每箱产品数',
    knift_car: '直刀卡',
    inside_degree: '内度',
    out_degree: '外度',
    size_degree: '尺寸(',
    length: '长度',
    width: '宽度',
    hight: '高度',
    indegree_size: '内度尺寸',
    box_item_code: '周转箱料号',
    per_box_exceed: '每箱重量超过',
    percarwithin: '每个卡板承载重量. 应<=',
    a_pack: 'A 压平包装',
    b_pack: 'B 立体包装',
    wrong_format: '输入的尺寸信息格式有误!',
    chose_result: '请选择计算结果',
    select_material: '请先选择纸箱材质信息',
    counting_wait: '计算中，请稍候！',
    youset_outrange: '你设置的卡板高度尺寸超出限制尺寸范围(',
    paper: '纸皮包裹',
    p_hand_in: '多个产品请手动输入产品包装尺寸!',
    sys_not_set: '系统中没有设定计算公式，请手动输入产品包装尺寸！',
    bjselect: '部件请选择物料信息',
    se_one: '请最少选择一种类型!',
    se_meterial: '纸箱的材质未选',
    se_bxtype: '纸箱的箱型未选',
    se_size: '请输入产品包装尺寸',
    num_info: '请输入纸箱数量信息!',
    too_big: '纸包尺寸过大，最大尺寸为：长',
    inwid: 'INCH、宽',
    inhigh: 'INCH、高',
    op_will_clear: '此操作会将已选择及输入的相关内容清空, 是否继续?',
    too_big_outsize: '外箱尺寸过大，最大尺寸为：长',
    too_small_outsize: '外箱尺寸过小，最小尺寸为：长',
    should_biger_than: '外度尺寸（长*宽*高）应该大于等于（产品包装尺寸长*宽*高*每箱产品数）',
    hight_size_is: '厚度(高)尺寸 = 产品成型尺寸高 =',
    cn_bc: '= 产品包装尺寸长 * 摆长 +',
    ck_bk: '= 产品包装尺寸宽 * 摆宽 +',
    cg_bg: '外度尺寸高度(MM) = 产品包装尺寸高 * 摆高 * 厚度系数 +',
    hdxs: '= 产品包装尺寸宽 * 摆宽 * 厚度系数 + ',
    gaodu: '外度尺寸高度(MM) = 产品包装尺寸高 * 摆高 +',
    remark: '*注：以上提示结果只为系统计算结果，如果实具数值有所不同可能是人工调整了。',
    size_wid: '外度尺寸宽度(MM)',
    Box_tape: '打箱带',
    Cartons: '纸箱',
    Pinka: '平卡',
    Knife_card: '刀卡',
    Turnover_box: '周转箱',
    Box: '箱',
    Ground_box: '地盒',
    Sky_Box: '天盒',
    One_piece: '一条',
    thick_coefficient1: '厚度系数',
    Auto_size: '自动尺寸',
    Number_of_products_per_case: '每箱产品数',
    Calculation: '测算',
    Weight_per_carton: '每箱重量',
    Dimension_of_horizontal_knife_clamp: '横刀卡尺寸',
    Thickness_height_dimension_description: '厚度(高)尺寸说明',
    Thickness_of_pit_paper: '坑纸厚度',
    The_pit_is_high: '坑楞高',
    Pit_paper: '坑纸',
    Layer_paper_press: '层面纸按',
    Each_floor: '每层',
    Totally: '合计',
  },
  packagePartCTN: {
    paper_pack: '纸包',
    package: '装箱',
    pack_way: '装箱方式',
    Gram_weight: '克重',
    brand: '品牌',
    lay_num: '层数',
    per_bag_num: '每包数量',
    Card_board: '卡板',
    click_to_set: '点击可以设置卡板尺寸信息',
    card_size_set: '设置卡板尺寸信息',
    Please_enter_the_pallet_dimensions: '请输入卡板尺寸信息',
    length: '长',
    width: '宽',
    tohight: '总高(含脚)',
    per_board_quantity: '每板数量',
    card_size: '刀卡尺寸(',
    num: '数量',
    b_c: '摆长',
    b_k: '摆宽',
    b_g: '摆高',
    perboxnum: '每箱数量',
    itemcode: '周转箱料号',
    ddts: '打带条数',
    length_out: '你设置的卡板长度尺寸超出最大限制尺寸(',
    width_out: '你设置的卡板宽度尺寸超出最大限制尺寸(',
    height_out: '你设置的卡板高度尺寸超出最大限制尺寸(',
    paper_box_type_never_chosed: '纸箱的箱型未选',
    Limit_the_total_height: '限总高',
  },
  packagePartBBK: {
    length: '长',
    width: '宽',
    in_box: '内箱',
    paper_pack: '纸包',
    package: '装箱',
    lay_way: '摆放方式',
    pack_way: '装箱方式',
    perbox_num: '每箱数量',
    tj: '推荐',
    lay: '摆放',
    size: '尺寸',
    load_num: '装箱数',
    weight: '重量',
    in_size: '内度尺寸(',
    knif_size: '刀卡尺寸(',
    a_pack: 'A 压平包装',
    b_pack: 'B 立体包装',
    box_itemno: '周转箱料号',
    nodata: '暂无数据',
    chose_result: '请选择计算结果',
    not_exist_instruction: '不存在说明书部件信息',
    instruction_item_no: '说明书部件请选择物料',
    not_fit_box: '没有合适的纸箱',
    nerver_chose_type: '纸箱的箱型未选',
  },
  outsourcingPart: {
    itemno: '物料编号',
    item_name: '物料名称',
    hole_paper: '(坑纸)',
    size_length: '尺寸长',
    size_width: '尺寸宽',
    size_height: '尺寸高',
    match_rate: '配比',
    modify: '修改',
  },
  fittingPart: {
    fit: '套件装配',
    buy_compoent: '外购配件',
    itemname: '物料名称',
    add_item: '添加物料',
    itemno: '物料编号',
    able: '启用',
    match_rate: '配比',
    attribute: '属性',
    null_item_name: '物料名称不能为空',
  },
  acMqPart: {
  },
}


// WEBPACK FOOTER //
// ./src/views/reqQuote/local/zh.js